function matchesRoutePrefix(pathname: string, route: string): boolean {
  if (!route) return false;

  const normalizedRoute = route.endsWith('/') ? route.slice(0, -1) : route;
  if (!normalizedRoute) return true;

  if (pathname === normalizedRoute) return true;

  return pathname.startsWith(`${normalizedRoute}/`);
}

export function matchesPromotionRoutes(
  pathname: string,
  routes?: string[],
  excludedRoutes?: string[],
): boolean {
  if (excludedRoutes?.some((route) => matchesRoutePrefix(pathname, route))) {
    return false;
  }

  if (!routes || routes.length === 0) {
    return true;
  }

  return routes.some((route) => matchesRoutePrefix(pathname, route));
}
